//import DomManipulate from 'modules/ready'
import Barba from 'barba.js'

//Transitions
import FadeTransition from 'modules/barbatransitions/fade'

//Views
import Home from 'modules/barbaviews/home'
import Works from 'modules/barbaviews/works'
import Work from 'modules/barbaviews/work'


/**
 * Init the events
 * Function to scroll to top of page
 * @param {scrollDuration} number
 */

function scrollToTop(scrollDuration) {
const   scrollHeight = window.scrollY,
        scrollStep = Math.PI / ( scrollDuration / 15 ),
        cosParameter = scrollHeight / 2;
var     scrollCount = 0,
        scrollMargin,
        scrollInterval = setInterval( function() {
            if ( window.scrollY != 0 ) {
                scrollCount = scrollCount + 1;
                scrollMargin = cosParameter - cosParameter * Math.cos( scrollCount * scrollStep );
                window.scrollTo( 0, ( scrollHeight - scrollMargin ) );
            }
            else clearInterval(scrollInterval);
        }, 15 );
}


//Init Views
Home.init();
Works.init();
Work.init();

//Edit Wrapper and container class objects
Barba.Pjax.Dom.wrapperId = 'main';
Barba.Pjax.Dom.containerClass = 'main__container';
Barba.scrollTop = function(){
  scrollToTop(1000);
  //Insert scrolltop function here.
}

let lastClickEl;
Barba.Dispatcher.on('linkClicked', (el) => {
  lastClickEl = el;
});


//## Currently commented out however this will need to be uncommented for google analytics to work.

// Barba.Dispatcher.on('initStateChange', function() {
//   if (typeof ga !== 'function' || Barba.HistoryManager.history.length <= 1) {
//     return;
//   }

//   ga('send', 'pageview', window.location.pathname);
// });


document.addEventListener("DOMContentLoaded", () => {
	Barba.Pjax.init();
	Barba.Prefetch.init();
});

/**
 * Next step, you have to tell Barba to use the new Transition
 */

Barba.Pjax.getTransition = function() {
  /**
   * Here you can use your own logic!
   * For example you can use different Transition based on the current page or link...
   */

  //Default Transition
  return FadeTransition;
};



// WEBPACK FOOTER //
// ./source/scripts/scripts/barba.js